import React from 'react';
import CarteScolaireNumerique from '../../components/dashboards/components/CarteScolaireNumerique';

const CarteScolaire = () => {
  return <CarteScolaireNumerique />;
};

export default CarteScolaire;
